import React, { useState, useEffect } from 'react';
import { Input } from 'reactstrap';
import { api_url } from "../globalFunction/global_string";

const SelectTenableNet = ({ id, name, requiredAPI, handleNetSelectChange, selectedNet, parentName }) => {
  const [options, setOptions] = useState([]);
  const current_user_type = localStorage.getItem('login_user_type');
  const local_net_id = localStorage.getItem('login_user_net_id');

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    let apiUrl = api_url + requiredAPI;
    const formData = new FormData();
    if (parentName === 'Excel' || parentName === 'superS') {
      formData.append("current_user_type", current_user_type);
      formData.append("local_net_id", local_net_id);
      formData.append("local_unit_id", localStorage.getItem('login_user_unit_id'));
    } else if (parentName === 'Statistical') {
      formData.append("current_user_type", current_user_type);
      formData.append("local_net_id", local_net_id);
      formData.append("local_unit_id", localStorage.getItem('login_user_unit_id'));
    }

    fetch(apiUrl, {
      method: "POST",
      headers: { "Authorization": localStorage.getItem('accessToken') },
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        let arr_status = [String(data.statusCode), data.row, data.detail]; // API 回傳判斷
        const rows = Array.isArray(arr_status[1]) ? arr_status[1] : [arr_status[1]];
        setOptions(rows);
      })
      .catch(error => {
        console.error('Error:', error);
      });
  };

  const handleSelectChange = (event) => {
    const { name, value } = event.target;
    const selectedIndex = event.target.selectedIndex;
    const selectedName = event.target.options[selectedIndex].text;
    handleNetSelectChange({ name, value, selectedName });
  };

  if (options.length === 0) {
    return <div>Loading...</div>; // 或其他載入中提示
  }

  return (
    <Input
      id={id}
      name={name}
      onChange={handleSelectChange}
      type='select'
      value={selectedNet} // 使用 prop 設置選擇的值
    >
      <option key="0" value="">
        請選擇
      </option>
      {options.map(option => (
        <option key={option.local_net_id} value={option.local_net_id}>
          {option.local_net_name}
        </option>
      ))}
    </Input>
  );
};

export default SelectTenableNet;
